module.exports = __webpack_public_path__ + "img/img_banner02_new.43f6f12f.png";